import { html, View } from 'rune-ts';
import klass from './ProductTitleView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { makeSubScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { pipe } from '@fxts/core';
import { CardProductError } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';
import { removeDLE } from '@services/MarppleShop/shared/util/removeDLE.ts';

export type TProps =
  | {
      size: '12px';
      adult: 'Off';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '13px';
      adult: 'Off';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '14px';
      adult: 'Off';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '15px';
      adult: 'Off';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '16px';
      adult: 'Off';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '12px';
      adult: 'On';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '13px';
      adult: 'On';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '14px';
      adult: 'On';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '15px';
      adult: 'On';
      domain_name: string;
      id: number;
      name: string;
    }
  | {
      size: '16px';
      adult: 'On';
      domain_name: string;
      id: number;
      name: string;
    };

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=368-189892&m=dev
 */
export class ProductTitleView extends View<TProps> {
  protected override template(props: TProps) {
    const href = `/${props.domain_name}/products/${props.id}`;

    const data_post_message = pipe(href, makeSubScreenNavigate, dataStr);

    if (props.size === '12px' && props.adult === 'Off') {
      return html`<a
        class="${classes(klass.text_layout, font('12_regular'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${pipe(props.name, removeDLE, html.preventEscape)}
      </a>`;
    } else if (props.size === '13px' && props.adult === 'Off') {
      return html`<a
        class="${classes(klass.text_layout, font('13_regular'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${pipe(props.name, removeDLE, html.preventEscape)}
      </a>`;
    } else if (props.size === '14px' && props.adult === 'Off') {
      return html`<a
        class="${classes(klass.text_layout, font('14_regular2'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${pipe(props.name, removeDLE, html.preventEscape)}
      </a>`;
    } else if (props.size === '15px' && props.adult === 'Off') {
      return html`<a
        class="${classes(klass.text_layout, font('15_regular'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${pipe(props.name, removeDLE, html.preventEscape)}
      </a>`;
    } else if (props.size === '16px' && props.adult === 'Off') {
      return html`<a
        class="${classes(klass.text_layout, font('16_medium'))}"
        href="${href}"
        data-post-message="${data_post_message}"
      >
        ${pipe(props.name, removeDLE, html.preventEscape)}
      </a>`;
    } else {
      // https://marpple.slack.com/archives/C05Q5T9TH8S/p1756884945017999?thread_ts=1756174138.512049&cid=C05Q5T9TH8S
      throw new CardProductError();
    }
  }
}
